/* Lisa's closet (sections/hw-closet.liquid). Reads the JSON the section prints, picks the video from ?video=,
   builds "Shop the video", favorites and FAQ. A piece opens its product page (no quick view since 24 Oct: the product
   page converts and carries shipping, returns and reviews). Branded since 26 Oct: the store header (bag, countdown) and
   footer show; every colour of a video piece is its own tile; "More like this" (hand-picked or Shopify related, same type); a "Meet Lisa" card. */
(function () {
  var root = document.querySelector('[data-hwc]');
  var dataEl = document.querySelector('[data-hwc-data]');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { console.error('[hw-closet] bad data', e); return; }
  var P = D.products || {}, S = D.settings || {};
  var $ = function (sel, el) { return (el || root).querySelector('[data-hwc-' + sel + ']'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var short = function (h) { return (P[h].title.split('|')[0] + ' ' + (P[h].title.split('|')[1] || '')).replace(/\s+/g, ' ').trim(); };
  var fill = function (t) { return String(t || '').replace(/\{size\}/g, S.size || 'M').replace(/\{height\}/g, S.height || ''); };

  var keys = Object.keys(D.videos || {});
  var want = new URLSearchParams(location.search).get('video');
  var vkey = (want && D.videos[want]) ? want : (D.videos[S.defaultVideo] ? S.defaultVideo : keys[0]);
  var V = vkey ? D.videos[vkey] : { title: '', caption: '', looks: [] };
  V.looks = (V.looks || []).map(function (l) { l.products = l.products.filter(function (h) { return P[h]; }); return l; });

  // video block
  var firstH = (V.looks[0] || {}).products ? V.looks[0].products[0] : null;
  var cover = V.cover || (V.looks[0] && V.looks[0].still) || (firstH && P[firstH].thumb) || '';
  $('cover').src = cover;
  // the look's name as a small line under her name, like an Instagram post header (Oliver 26 Oct); no text under the video
  $('title').textContent = fill(V.title || '');
  $('title').hidden = !V.title;
  // creator row: a still from this video, so the face matches the woman she just watched (the look's still first:
  // the cover is the ad's frame 1 and often carries the hook text)
  var avImg = (V.looks[0] && V.looks[0].still) || V.cover || '';
  if (avImg) $('av').style.backgroundImage = 'url("' + avImg.replace(/"/g, '%22') + '")';
  $('shoplabel').textContent = V.shopLabel || 'Shop the video';
  var vbtn = $('video'), player = $('player'), ctl = $('ctl');
  var silent = false, heard = false, hideT, autoPaused = false;
  var fmt = function (t) { t = Math.max(0, Math.floor(t || 0)); return Math.floor(t / 60) + ':' + ('0' + t % 60).slice(-2); };
  var go = function () { var p = player.play(); if (p && p.catch) p.catch(function () { vbtn.classList.add('blocked'); }); };
  // Controls (sound, play/pause, progress, time) like LTK / Instagram: visible when the video starts and on every tap,
  // they fade after 5 s while it plays and stay while it is paused
  var show = function () {
    vbtn.classList.add('ctl-on'); clearTimeout(hideT);
    hideT = setTimeout(function () { if (!player.paused) vbtn.classList.remove('ctl-on'); }, 5000);
  };
  var sync = function () {
    vbtn.classList.toggle('paused', player.paused);
    vbtn.classList.toggle('muted', player.muted);
    $('pp').setAttribute('aria-label', player.paused ? 'Play' : 'Pause');
    $('mute').setAttribute('aria-label', player.muted ? 'Turn sound on' : 'Turn sound off');
  };
  var sound = function (on) {  // the first time she turns the sound on, the clip starts over so she hears the hook
    player.muted = !on;
    if (on && !heard) { heard = true; player.currentTime = 0; }
    if (player.paused) player.play();
    show();
  };
  if (!V.video) { $('big').style.display = 'none'; ctl.style.display = 'none'; }
  else {
    // Muted autoplay, like the ad she just watched (muted + playsinline may autoplay on every phone browser); it plays
    // once and stops at the end with the play button and controls showing (Oliver, 24 Oct: no loop).
    // It starts once the cover has loaded, so the cover comes first. If the phone blocks it (iPhone Low Power Mode),
    // the cover + play button stay and a tap plays it with sound.
    player.muted = true;
    $('time').textContent = '0:00 / ' + (V.length || '');
    var start = function () { player.src = V.video; player.preload = 'auto'; go(); };
    var img = $('cover');
    if (!img.getAttribute('src') || img.complete) start(); else { img.addEventListener('load', start); img.addEventListener('error', start); }
    player.addEventListener('playing', function () {
      if (player.hidden) { player.hidden = false; show(); }
      vbtn.classList.remove('blocked');
    });
    ['play', 'pause', 'volumechange'].forEach(function (ev) { player.addEventListener(ev, sync); });
    player.addEventListener('pause', function () { if (!autoPaused) show(); });
    player.addEventListener('timeupdate', function () {
      var d = player.duration || 0;
      $('fill').style.width = (d ? player.currentTime / d * 100 : 0) + '%';
      $('time').textContent = fmt(player.currentTime) + ' / ' + (d ? fmt(d) : V.length || '');
    });
    player.addEventListener('error', function () {  // no 720p file: the full one
      if (!V.videoFull || player.getAttribute('src') === V.videoFull) return;
      player.src = V.videoFull; if (player.muted) go(); else player.play();
    });
    // The sound button only on clips that have sound (Firefox: mozHasAudio, Safari: audioTracks, Chrome: decoded audio bytes)
    player.addEventListener('timeupdate', function check() {
      if (player.currentTime < 0.5) return;
      player.removeEventListener('timeupdate', check);
      if (typeof player.mozHasAudio === 'boolean') silent = !player.mozHasAudio;
      else if (player.audioTracks) silent = !player.audioTracks.length;
      else if (typeof player.webkitAudioDecodedByteCount === 'number') silent = !player.webkitAudioDecodedByteCount;
      if (!silent) vbtn.classList.add('has-sound');
    });
    // pause the muted video when she scrolls past it (data, battery) and play it again when she is back;
    // with sound it keeps playing while she shops, and a video she paused herself stays paused
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) {
      if (!player.getAttribute('src') || !player.muted) return;
      if (e[0].isIntersecting) { if (autoPaused) { autoPaused = false; go(); } }
      else if (!player.paused) { autoPaused = true; player.pause(); }
    }, { threshold: 0.25 }).observe(vbtn);
    $('mute').addEventListener('click', function (e) { e.stopPropagation(); sound(player.muted); });
    $('pp').addEventListener('click', function (e) { e.stopPropagation(); if (player.paused) player.play(); else player.pause(); show(); });
    $('prog').addEventListener('click', function (e) {
      e.stopPropagation();
      var r = this.getBoundingClientRect();
      if (player.duration) player.currentTime = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) * player.duration;
      show();
    });
    $('big').addEventListener('click', function (e) {  // shows when paused or when the phone blocked autoplay
      e.stopPropagation();
      if (vbtn.classList.contains('blocked')) { if (!player.getAttribute('src')) player.src = V.video; sound(!silent); }
      else { player.play(); show(); }
    });
    // a tap on the video: controls hidden = show them; controls showing = pause / play
    vbtn.addEventListener('click', function () {
      if (vbtn.classList.contains('blocked')) return $('big').click();
      if (!vbtn.classList.contains('ctl-on')) return show();
      if (player.paused) player.play(); else player.pause();
      show();
    });
  }

  // photo post / carousel (no video): the ad's slides in the ad's order, in their own shape (4:5 carousels,
  // 9:16 photos). Slides are not tied to products (a slide can be a hook card or a close-up); a tap goes to the products.
  var slides = [];
  if (!V.video) slides = (V.slides && V.slides.length ? V.slides : [cover]).filter(Boolean).map(function (u) { return { src: u }; });
  if (slides.length) {
    var post = document.createElement('div'); post.className = 'hwc-post';
    var many = slides.length > 1;
    post.innerHTML = '<div class="hwc-ptrack">' + slides.map(function (sl) {
      return '<div class="hwc-slide"><img src="' + esc(sl.src) + '" alt=""></div>';
    }).join('') + '</div>' + (many ? '<button type="button" class="hwc-gnav l" aria-label="Previous photo">' + chev('15 18 9 12 15 6') +
      '</button><button type="button" class="hwc-gnav r" aria-label="Next photo">' + chev('9 18 15 12 9 6') + '</button><span class="hwc-gcount">1 / ' + slides.length + '</span>' : '');
    vbtn.replaceWith(post);
    if (many) {
      var dots = document.createElement('div'); dots.className = 'hwc-gdots';
      dots.innerHTML = slides.map(function (_, i) { return '<i class="' + (i ? '' : 'on') + '"></i>'; }).join('');
      post.after(dots);
    }
    var ptrack = post.querySelector('.hwc-ptrack');
    post.querySelector('img').addEventListener('load', function () {
      var r = this.naturalWidth / this.naturalHeight;
      if (r < 0.7) post.classList.add('tall'); else post.style.aspectRatio = this.naturalWidth + ' / ' + this.naturalHeight;
    });
    if (many) {
      var pgo = function (d) { var n = slides.length, i = Math.round(ptrack.scrollLeft / ptrack.clientWidth); ptrack.scrollTo({ left: ((i + d + n) % n) * ptrack.clientWidth, behavior: 'auto' }); };
      post.querySelector('.hwc-gnav.l').onclick = function () { pgo(-1); };
      post.querySelector('.hwc-gnav.r').onclick = function () { pgo(1); };
      ptrack.addEventListener('scroll', function () {
        var i = Math.round(ptrack.scrollLeft / ptrack.clientWidth);
        post.querySelector('.hwc-gcount').textContent = (i + 1) + ' / ' + slides.length;
        dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('on', k === i); });
      });
    }
    ptrack.addEventListener('click', function () { document.getElementById('hwc-shop').scrollIntoView({ behavior: 'smooth' }); });
  }

  // grids
  var pieces = [];
  V.looks.forEach(function (l) { l.products.forEach(function (h) { if (pieces.indexOf(h) < 0) pieces.push(h); }); });
  var lookOf = function (h) { for (var i = 0; i < V.looks.length; i++) if (V.looks[i].products.indexOf(h) > -1) return i; return -1; };
  // A tap opens the product page (shipping, returns, reviews, size guide all live there) with the video's colour selected
  // a look's colour per product may hold several colours ("Black + Green") when the video shows the piece in more than one
  var lookColors = function (l, i) {
    var v = Array.isArray(l.colors) && l.colors[i];
    return v ? String(v).split('+').map(function (s) { return s.trim(); }).filter(Boolean) : [];
  };
  var lookColor = function (h) {
    var c = null;
    V.looks.forEach(function (l) { var i = l.products.indexOf(h); if (c === null && i > -1) c = lookColors(l, i)[0] || null; });
    return c;
  };
  var colIdx = function (p) { var ci = -1; p.options.forEach(function (o, i) { if (/colou?r/i.test(o)) ci = i; }); return ci; };
  var href = function (h, c) {
    var p = P[h], ci = colIdx(p);
    if (c === undefined) c = lookColor(h);
    var inColor = c && ci > -1 ? p.variants.filter(function (v) { return v.o[ci] === c; }) : [];
    var v = inColor.filter(function (x) { return x.a; })[0] || inColor[0];
    // the page already opens on the first colour in stock, on its first (hero) photo; ?variant= would jump the gallery
    // to that colour's variant photo (on older listings a supplier photo), so only link a colour that needs choosing
    var first = p.variants.filter(function (x) { return x.a; })[0] || p.variants[0];
    if (v && first && first.o[ci] === c) v = null;
    return p.url + (v ? '?variant=' + v.id : '');
  };
  var imgOf = function (h, c) {
    var p = P[h], ci = colIdx(p);
    // the colour's hero photo (its variant image), like the store's own cards (Oliver 26 Oct: "the normal hero")
    if (c === null || ci < 0) return p.thumb;
    var v = p.variants.filter(function (x) { return x.o[ci] === c && x.img; })[0];
    return v ? v.img : p.thumb;
  };
  // Tile (Oliver 26 Oct): the product's hero photo and the price; no name or colour (both are on the product page).
  // Photo or price = product page; the round bag button = quick view (a small product page in a sheet).
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12v4M10 14h4"/></svg>';
  var tile = function (h, tag, c) {
    if (c === undefined) c = null;
    var p = P[h], url = esc(c === null ? href(h) : href(h, c)), name = esc(short(h) + (c ? ', ' + c : ''));
    return '<div class="hwc-prod">' +
      '<div class="hwc-pimg"><a href="' + url + '" aria-label="' + name + '"><img src="' + esc(imgOf(h, c)) + '" alt="" loading="lazy"></a>' +
      // no colour label (Oliver 26 Oct): the photo shows the colour; only a "Look n" tag when a video has several looks
      (tag ? '<span class="hwc-lk">' + esc(tag) + '</span>' : '') +
      '<button type="button" class="hwc-qa" data-qa="' + esc(h) + '" data-qc="' + esc(c || '') + '" aria-label="Quick view ' + name + '">' + BAG + '</button></div>' +
      '<a class="hwc-meta" href="' + url + '">' +
      '<span class="hwc-pr"><b>' + money(p.price) + '</b>' + (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') + '</span></a></div>';
  };
  var multiLook = V.video && V.looks.length > 1;
  // one tile per piece, like the store's own cards (Oliver 26 Oct: "just the product hero and price tag"); the tap
  // still opens the product page on the video's colour. A piece the video shows in several colours gets a tile per
  // colour, each with that colour's hero photo.
  var shown = {};
  V.looks.forEach(function (l) {
    l.products.forEach(function (h, i) {
      shown[h] = shown[h] || [];
      lookColors(l, i).forEach(function (c) { if (shown[h].indexOf(c) < 0) shown[h].push(c); });
    });
  });
  var tiles = [];
  pieces.forEach(function (h) {
    var tag = multiLook ? 'Look ' + (lookOf(h) + 1) : '';
    if (shown[h].length > 1) shown[h].forEach(function (c) { tiles.push(tile(h, tag, c)); });
    else tiles.push(tile(h, tag));
  });
  $('pcount').textContent = pieces.length + (pieces.length === 1 ? ' piece' : ' pieces') +
    (tiles.length > pieces.length ? ' · ' + tiles.length + ' colors' : '');
  $('grid').innerHTML = tiles.join('');
  // More like this (Oliver 26 Oct): the video's hand-picked list wins; without one, Shopify's own related products of
  // the video's first piece (ranked by what shoppers view and buy together), only the same type (a dress video shows
  // dresses; sweaters and cardigans count as one group), max 4. Fewer than 2 matches: Lisa's favorites instead.
  var showFavs = function () {
    var favs = (S.favorites || []).filter(function (h) { return P[h] && pieces.indexOf(h) < 0; }).slice(0, 6);
    $('favs').innerHTML = favs.map(function (h) { return tile(h, ''); }).join('');
    $('favsec').hidden = !favs.length;
  };
  var showMore = function (list) {
    $('more').innerHTML = list.map(function (h) { return tile(h, ''); }).join('');
    $('moresec').hidden = false;
    $('favsec').hidden = true;
  };
  var group = function (t) { t = String(t || '').toLowerCase(); return /sweater|cardigan/.test(t) ? 'knit' : t; };
  // a product from Shopify's Ajax JSON in the same shape as the section's product data
  var sized = function (u) { return u ? String(u).split('&width=')[0] + (String(u).indexOf('?') > -1 ? '&' : '?') + 'width=500' : null; };
  var fromAjax = function (x) {
    return {
      id: x.id, type: x.type, title: x.title, url: x.url, price: x.price, compare: x.compare_at_price || x.price, low: true,
      thumb: sized(x.featured_image), options: (x.options || []).map(function (o) { return o.name || o; }),
      variants: (x.variants || []).map(function (v) { return { id: v.id, o: v.options, a: v.available, img: v.featured_image ? sized(v.featured_image.src) : null }; })
    };
  };
  var more = (V.more || []).filter(function (h) { return P[h] && pieces.indexOf(h) < 0; });
  var lead = pieces[0] && P[pieces[0]];
  if (more.length) showMore(more);
  else if (!lead || !lead.id) showFavs();
  else {
    $('favsec').hidden = true;
    var settled = false, fallback = function () { if (!settled) { settled = true; showFavs(); } };
    var slowRec = setTimeout(fallback, 4000);
    var recRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(recRoot + 'recommendations/products.json?product_id=' + lead.id + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (settled) return;
        settled = true; clearTimeout(slowRec);
        // never the same piece under another listing (the store has older duplicates, e.g. a second Ingrid at another price)
        var shownTitles = pieces.map(function (h) { return P[h].title.toLowerCase().trim(); });
        var list = (d.products || []).filter(function (x) {
          var t = String(x.title).toLowerCase().trim();
          if (!x.available || group(x.type) !== group(lead.type) || pieces.indexOf(x.handle) > -1 || shownTitles.indexOf(t) > -1) return false;
          shownTitles.push(t);  // and only one of two duplicate listings
          return true;
        }).slice(0, 4);
        list.forEach(function (x) { if (!P[x.handle]) P[x.handle] = fromAjax(x); });
        if (list.length >= 2) showMore(list.map(function (x) { return x.handle; })); else showFavs();
      })
      .catch(fallback);
  }
  // Meet card: a still from this video (the woman she just watched) + the size she wears
  // the look's still first: the cover is the ad's frame 1 and often carries the hook text
  var meetImg = (V.looks[0] && V.looks[0].still) || V.cover || '';
  if (meetImg) $('meetph').style.backgroundImage = 'url("' + meetImg.replace(/"/g, '%22') + '")';
  var sz = S.size || 'M';
  $('meetsize').textContent = 'Wears ' + (/^[SMLFHX8]/i.test(sz) ? 'an ' : 'a ') + sz + (S.height ? ' · ' + S.height + ' tall' : '');
  // The product page remembers "size chosen" per visit (snippets/hw-require-size, key 'hw-size-chosen:' + path) and would
  // then accept the link's size; clear it so she always picks her size there
  // (one listener for all tiles, also the ones "More like this" adds later)
  root.addEventListener('click', function (e) {
    var a = e.target.closest('.hwc-prod a');
    if (a) { try { sessionStorage.removeItem('hw-size-chosen:' + a.pathname); } catch (er) {} }
  });

  // Quick view (Oliver 26 Oct): a compact sheet, only as tall as its content, built from the product page's own parts
  // (same review line, price row with "You save" / "Traditional retail", COLOR | value legend, square photo swatches,
  // square size buttons, Low in stock with the red dot, ADD TO BAG) so it feels like our store, not a copy of Birdsnest.
  // Add to bag = /cart/add.js, so Upcart, the pixel and Lasso work as on the product page. The photo and "See all
  // details" open the product page on the chosen colour.
  var sheet = $('sheet'), scrim = $('scrim'), qv = $('qv'), addBtn = $('add');
  function partner(h) {
    var out = null;
    V.looks.forEach(function (l) { if (!out && l.products.indexOf(h) > -1) l.products.forEach(function (x) { if (!out && x !== h) out = x; }); });
    return out;
  }
  function openQV(h, want) {
    var p = P[h], ci = -1, si = -1;
    p.options.forEach(function (o, i) { if (/colou?r/i.test(o)) ci = i; if (/size/i.test(o)) si = i; });
    var colors = [], sizes = [];
    p.variants.forEach(function (v) {
      if (ci > -1 && colors.indexOf(v.o[ci]) < 0) colors.push(v.o[ci]);
      if (si > -1 && sizes.indexOf(v.o[si]) < 0) sizes.push(v.o[si]);
    });
    var inStock = function (c) { return p.variants.some(function (v) { return v.o[ci] === c && v.a; }); };
    want = want || lookColor(h);
    var color = null, size = null;
    if (ci > -1) color = (want && colors.indexOf(want) > -1) ? want : (colors.filter(inStock)[0] || colors[0]);
    var findV = function () { return p.variants.filter(function (v) { return (ci < 0 || v.o[ci] === color) && (si < 0 || v.o[si] === size); })[0]; };
    var pair = partner(h);
    var save = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
    qv.innerHTML =
      '<div class="hwc-qvin hwc-gut">' +
      '<div class="hwc-qtop"><a class="hwc-qimg" data-det href="#"><img alt=""></a><div class="hwc-qinfo">' +
      // short version of the product page's review line (templates/product.json: 4.8 / 5, 483 reviews), so both agree
      '<div class="hwc-qrev"><span class="hwc-qstars" aria-hidden="true">★</span><b>4.8</b>&nbsp;/ 5<span>(483)</span></div>' +
      '<h3>' + esc(p.title) + '</h3>' +
      '<div class="hwc-qprice"><b>' + money(p.price) + '</b>' + (save ? '<s>' + money(p.compare) + '</s><span>You save ' + save + '%</span>' : '') + '</div>' +
      '</div></div>' +
      (ci > -1 && colors.length > 1 ? '<div class="hwc-qleg"><b>Color</b><span data-c>' + esc(color) + '</span></div><div class="hwc-sw" data-colors>' +
        colors.map(function (c) {
          return '<button type="button" class="hwc-swb" data-v="' + esc(c) + '" aria-pressed="' + (c === color) + '" aria-label="' + esc(c) + (inStock(c) ? '' : ', sold out') + '"' + (inStock(c) ? '' : ' data-out') + ' style="background-image:url(&quot;' + esc(imgOf(h, c)) + '&quot;)"></button>';
        }).join('') + '</div>' : '') +
      (si > -1 ? '<div class="hwc-qleg"><b>Size</b><span data-sl></span><button type="button" class="hwc-qchart" data-sg aria-expanded="false">Size Chart</button></div><div class="hwc-qsizes" data-sizes></div>' +
        '<div class="hwc-guide" data-guide hidden><p><b>Fits true to size.</b> Take your usual size. Body measurements in inches:</p><table><thead><tr>' +
        D.bodyTable[0].map(function (c) { return '<th>' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>' +
        D.bodyTable.slice(1).map(function (r) { return '<tr data-s="' + esc(r[0]) + '">' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>'; }).join('') +
        '</tbody></table></div>' : '') +
      (p.low ? '<div class="hwc-qlow"><i aria-hidden="true"></i><span>Low in stock</span></div>' : '') +
      '<a class="hwc-qmore" data-det href="#">See all details</a>' +
      (pair ? '<div class="hwc-pair"><img src="' + esc(P[pair].thumb) + '" alt=""><div><b>' + esc(S.name ? S.name.split(' ')[0] : 'Lisa') + ' wears it with the ' + esc(short(pair).split(' ').slice(1).join(' ')) + '</b><span>' + money(P[pair].price) + '</span></div><button type="button" data-pair="' + esc(pair) + '">View</button></div>' : '') +
      '</div>';
    var dets = qv.querySelectorAll('[data-det]');
    function showColor() {
      qv.querySelector('.hwc-qimg img').src = imgOf(h, color);
      dets.forEach(function (a) { a.href = href(h, color); });
    }
    // the product page remembers "size chosen" per visit; clear it so she still picks her size there
    dets.forEach(function (a) { a.addEventListener('click', function () { try { sessionStorage.removeItem('hw-size-chosen:' + a.pathname); } catch (e) {} }); });
    function renderSizes() {
      var box = qv.querySelector('[data-sizes]'); if (!box) return;
      box.innerHTML = sizes.map(function (s) {
        var v = p.variants.filter(function (x) { return (ci < 0 || x.o[ci] === color) && x.o[si] === s; })[0];
        var ok = v && v.a;
        return '<button type="button" class="hwc-opt" data-v="' + esc(s) + '" aria-pressed="' + (s === size) + '"' + (ok ? '' : ' disabled aria-label="' + esc(s) + ' sold out"') + '>' + esc(s) + '</button>';
      }).join('');
      qv.querySelector('[data-sl]').textContent = size || '';
      box.querySelectorAll('.hwc-opt').forEach(function (b) {
        b.onclick = function () {
          size = b.getAttribute('data-v');
          box.querySelectorAll('.hwc-opt').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          qv.querySelector('[data-sl]').textContent = size;
          qv.querySelectorAll('[data-guide] tr').forEach(function (r) { r.classList.toggle('me', r.getAttribute('data-s') === size); });
          updateBtn();
        };
      });
    }
    function updateBtn() {
      var v = findV();
      if (si > -1 && !size) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = 'Choose your size'; return; }
      if (!v || !v.a) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = 'Sold out'; return; }
      addBtn.setAttribute('aria-disabled', 'false'); addBtn.textContent = 'Add to bag';
    }
    var cbox = qv.querySelector('[data-colors]');
    if (cbox) cbox.querySelectorAll('.hwc-swb').forEach(function (b) {
      b.onclick = function () {
        color = b.getAttribute('data-v');
        cbox.querySelectorAll('.hwc-swb').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        qv.querySelector('[data-c]').textContent = color;
        if (size) { var still = findV(); if (!still || !still.a) size = null; }
        showColor(); renderSizes(); updateBtn();
      };
    });
    var sg = qv.querySelector('[data-sg]');
    if (sg) sg.onclick = function () {
      var gd = qv.querySelector('[data-guide]'); gd.hidden = !gd.hidden;
      sg.setAttribute('aria-expanded', String(!gd.hidden)); sg.textContent = gd.hidden ? 'Size Chart' : 'Hide Size Chart';
    };
    var pb = qv.querySelector('[data-pair]'); if (pb) pb.onclick = function () { openQV(pb.getAttribute('data-pair')); };
    showColor(); renderSizes(); updateBtn();
    addBtn.onclick = function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') {
        toast(si > -1 && !size ? 'Tap your size first' : 'This size is sold out');
        return;
      }
      addToBag(findV().id);
    };
    qv.scrollTop = 0;
    sheet.classList.add('on'); scrim.classList.add('on'); document.documentElement.style.overflow = 'hidden';
  }
  function closeQV() { sheet.classList.remove('on'); scrim.classList.remove('on'); document.documentElement.style.overflow = ''; }
  $('close').onclick = closeQV; scrim.onclick = closeQV;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qa]');
    if (b) { e.preventDefault(); openQV(b.getAttribute('data-qa'), b.getAttribute('data-qc') || null); }
  });
  function addToBag(id) {
    addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = 'Adding…';
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add'); }); return r.json(); })
      .then(function () {
        closeQV();
        setTimeout(function () { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); else location.href = '/cart'; }, 150);
      })
      .catch(function (e) { toast(e.message); addBtn.setAttribute('aria-disabled', 'false'); addBtn.textContent = 'Add to bag'; });
  }
  var tt; function toast(m) { var t = $('toast'); t.textContent = m; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('on'); }, 2600); }
  $('faq').innerHTML = (S.faq || []).map(function (x) { return '<details><summary>' + esc(fill(x.q)) + '</summary><p>' + esc(fill(x.a)) + '</p></details>'; }).join('');

  function chev(pts) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="' + pts + '"/></svg>'; }
})();
